import React from 'react';
import { undoIcon } from '@chordbaker/design';

interface UndoIconProps {
  size?: number;
  color?: string;
  style?: React.CSSProperties;
}

const UndoIcon: React.FC<UndoIconProps> = ({
  size = 16,
  color = 'currentColor',
  style
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox={undoIcon.viewBox}
      fill={undoIcon.fill}
      stroke={color}
      strokeWidth={undoIcon.strokeWidth}
      strokeLinecap={undoIcon.strokeLinecap as React.SVGAttributes<SVGSVGElement>['strokeLinecap']}
      strokeLinejoin={undoIcon.strokeLinejoin as React.SVGAttributes<SVGSVGElement>['strokeLinejoin']}
      style={style}
    >
      {undoIcon.elements.map((element, i) => (
        <path key={i} d={(element as { d: string }).d} />
      ))}
    </svg>
  );
};

export default UndoIcon;
